// extracted by mini-css-extract-plugin
export default {"footerDots":"footerDots_footerDots__2E+oj","main":"footerDots_main__2fRgI"};